/* eslint-disable simple-import-sort/imports */
import { createBrowserRouter, createRoutesFromElements, Route, useLocation } from 'react-router-dom';

import { PageRoutes } from './constants';
import Layout from '../layout';
import { MaintenancePage } from '../pages/MaintenancePage';
import { Page } from '@components/shared/Page';
import { AppRoute } from '@models/routeProps';

const QueryParamsNavigator = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const path = page ? `/${page}` : '/';
  const route: AppRoute = PageRoutes().find((route) => route.path === path)!;

  return (
    <Layout title={route.title}>
      <Page component={route.component} title={route.title} />
    </Layout>
  );
};

export const AppRoutes = () => {
  const basename = import.meta.env.VITE_PUBLIC_URL;
  const inMaintenance = import.meta.env.VITE_APP_IN_MAINTENANCE === 'true';

  if (inMaintenance) {
    return createBrowserRouter(
      createRoutesFromElements(
        <Route
          path='*'
          element={
            <Layout title='Maintenance'>
              <MaintenancePage />
            </Layout>
          }
        />
      ),
      { basename }
    );
  }

  return createBrowserRouter(createRoutesFromElements(<Route path='*' element={<QueryParamsNavigator />} />), { basename });
};
